import LikeIcon from "@/components/Like/LikeIcon";
import ShareIcon from "@/components/Share/ShareIcon";
import { useRemoveCollection } from "@/hooks/useCollection";
import useTranslation from "@/hooks/useTranslation";
import { sanitize } from "@/utils/sanitize.util";
import { shortUUID } from "@/utils/string.util";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  useMediaQuery,
} from "@material-ui/core";
import { Descriptions, PageHeader } from "antd";
import moment from "moment";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useState } from "react";

interface IProps {
  name: string;
  description: string;
  username: string;
  size: number;
  updated_at: string;
  _public: boolean;
  id: string;
}

const CollectionPageHeader: React.FC<IProps> = ({
  name,
  description,
  username,
  id,
  size,
  updated_at,
  _public,
}) => {
  const router = useRouter();
  const { t } = useTranslation("bundle");
  const { removeCollection, loading } = useRemoveCollection();
  const [open, setOpen] = useState(false);
  const matches = useMediaQuery("(max-width:600px)");
  const buttonSize = matches ? "small" : "medium";
  return (
    <>
      <PageHeader
        onBack={() => router.back()}
        title={name}
        subTitle={`${moment(updated_at).fromNow()}`}
        extra={[
          <ShareIcon
            url={`https://www.medicgo.org/bundle/collection/${shortUUID(id)}`}
            title={name}
            key="0"
          />,
          <LikeIcon fatherId={id} key="1" />,
          <Link
            href="/bundle/collection/[id]/update"
            as={`/bundle/collection/${shortUUID(id)}/update`}
            key="2"
          >
            <Button
              key="22"
              color="default"
              variant="outlined"
              size={buttonSize}
            >
              {t("collection.page.button.update")}
            </Button>
          </Link>,
          <Button
            key="3"
            variant="outlined"
            color="default"
            onClick={() => setOpen(true)}
            size={buttonSize}
            disabled={loading}
          >
            {t("collection.page.button.delete")}
          </Button>,
        ]}
      >
        <p dangerouslySetInnerHTML={{ __html: sanitize(description) }} />
        <Descriptions
          size="small"
          column={{ xs: 1, sm: 1, md: 1, lg: 3 }}
          bordered
        >
          <Descriptions.Item label={t("collection.page.owner")}>
            {username}
          </Descriptions.Item>
          <Descriptions.Item label={t("collection.page.size")}>
            {size}
          </Descriptions.Item>
          <Descriptions.Item label={t("collection.page.privacy.itself")}>
            {_public
              ? t("collection.page.privacy.public")
              : t("collection.page.privacy.private")}
          </Descriptions.Item>
        </Descriptions>
      </PageHeader>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{t("collection.page.delete-info")}</DialogTitle>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            {t("common:back-home")}
          </Button>
          <Button
            onClick={() => {
              removeCollection(id);
              setOpen(false);
            }}
            color="primary"
            autoFocus
          >
            {t("common:submit")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CollectionPageHeader;
